module.exports = __webpack_public_path__ + "img/dq-contrib-txt.982368f9.png";